import { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
import axios from "axios";
import Header from "components/Headers/Header.js";
import Loader from "components/Loader.js"; // ✅ Import do loader

const API_URL = process.env.REACT_APP_API_URL;

const Index = () => {
  const [countriesWithCopyCount, setCountriesWithCopyCount] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Estado para o loader

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API_URL}/countries`);
        const countries = response.data;

        const results = await Promise.all(
          countries.map(async (country) => {
            const [copiesRes, groupsRes] = await Promise.all([
              axios.get(`${API_URL}/copies/country/${country.id}`),
              axios.get(`${API_URL}/groups/by-country/${country.id}`)
            ]);

            return {
              name: country.name,
              total: copiesRes.data.length,
              groupCount: groupsRes.data.length
            };
          })
        );

        setCountriesWithCopyCount(results);
      } catch (error) {
        console.error("Erro ao buscar dados de países, cópias e grupos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ✅ Exibe o loader enquanto os dados ainda estão sendo carregados
  if (loading) {
    return (
      <>
        <Header />
        <Loader />
      </>
    );
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          {/* 🔹 Tabela de grupos por país */}
          <Col className="mb-5 mb-xl-0" xl="7">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Distribuição de Grupos por País</h3>
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">País</th>
                    <th scope="col">Qtd. de Grupos</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {countriesWithCopyCount.map((item, index) => (
                    <tr key={index}>
                      <th scope="row">{item.name}</th>
                      <td>{item.groupCount || 0}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="mr-2">
                            {(item.groupCount || 0) * 10}%
                          </span>
                          <div>
                            <Progress
                              max="100"
                              value={(item.groupCount || 0) * 10}
                              barClassName={
                                index % 2 === 0
                                  ? "bg-gradient-success"
                                  : "bg-gradient-warning"
                              }
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </Col>

          {/* 🔹 Tabela de cópias por país */}
          <Col xl="5">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Total de Cópias por País</h3>
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">País</th>
                    <th scope="col">Qtd. de Cópias</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {countriesWithCopyCount.map((item, index) => (
                    <tr key={index}>
                      <th scope="row">{item.name}</th>
                      <td>{item.total}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="mr-2">{item.total * 1}%</span>
                          <div>
                            <Progress
                              max="100"
                              value={item.total * 1}
                              barClassName={
                                index % 2 === 0
                                  ? "bg-gradient-info"
                                  : "bg-gradient-danger"
                              }
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Index;